export const constantsObject = {
    registrationFailedHeading: "Registration failed",
    registrationFailedBody: "Don’t worry – we have a support team ready to sort this out. Call the CRU team at 1-877-500-2386.\n\nIn the meantime you may still download your card.",
    internalServerErrorHeading: "Our servers are undergoing updates",
    internalServerErrorBody: "In the meantime, you can download and save your card",
    notFoundErrorHeading: "This page is not available",
    notFoundErrorBody: "In the meantime, you can download and save your card",
}
